import React from "react";

import { LayoutContainer } from "./LayoutContainer";
import { StaticImage } from "gatsby-plugin-image";

interface Props {
  title: string;
  subTitle: string;
}

export const PageIntro = (props: Props) => {
  return (
    <div className="relative overflow-hidden bg-black pt-16">
      <StaticImage alt="" src="../images/page-intro.png" className="blur-3xl scale-125 absolute inset-0" />
      <LayoutContainer className="md:py-28 py-12 text-center md:text-left relative z-10">
        <div className="text-4xl md:text-6xl">{props.title}</div>
        {props.subTitle && (
          <div className="opacity-80 mt-3">{props.subTitle}</div>
        )}
      </LayoutContainer>
    </div>
  );
};
